// extracted by mini-css-extract-plugin
export var settingsList = "_3j-0";
export var settingsRow = "_3j-1";
export var warningDot = "_3j-2";